module.exports = __webpack_public_path__ + "static/media/close_popup.be7e7151.svg";